import { base } from "./base";

export const http = {
  get: (url, params) => base.get(url, params),
  get_pdf: (url, params) => base.get_pdf(url, params),
  post: (url, data) => base.post(url, data),
  put: (url, data) => base.put(url, data),
  patch: (url, data) => base.patch(url, data),
  delete: (url, config) => base.delete(url, config),
  postFormData: (url, data) => base.postFormData(url, data),
  postMail: (url, data) => base.postMail(url, data),
  postUser: (url, data) => base.postUser(url, data),
};